import React from "react";
import SVG, { Props as SVGProps } from "react-inlinesvg";

const Icon = ({ filename, ...rest }) => {
  return <SVG {...rest} src={rest.src || `/svg/${filename}.svg`} />;
};

export default Icon;
